import React from 'react';
import ProfilePage from './ProfilePage';
import FeesPayment from './FeesPayment';
import CertificatePage from './CertificatePage';
import { usePageContainer } from '../../hooks/usePageContainer';
import PageContainerLayout from '../../components/layout/PageContainer/PageContainerLayout';
import { useSearchParams } from 'react-router-dom';
import Button from '../../components/reusableComponents/buttons/button11';
import ChangePasswordPage from './ChangePasswordPage';


// Import profile-related icons
import profileIcon from '../../assets/profile/ProfilePage.svg';
import feesIcon from '../../assets/profile/Fees.svg';
import ChangePasswordIcon from '../../assets/profile/ChangePassword.svg'
// import certificateIcon from '../../assets/profile/Certificates.svg'; // Make sure this exists

const ProfilePageContainer = () => {
  const [searchParams] = useSearchParams();
  
  // Define page configuration
  const profilePages = {
    'profile': {
      component: <ProfilePage />,
      icon: profileIcon
    },
    'fees': {
      component: <FeesPayment />,
      icon: feesIcon
    },
    'certificate': {
      component: <CertificatePage />,
      icon: feesIcon // Use certificate icon if available
    },
    'change-password': {
      component: <ChangePasswordPage />,
      icon: ChangePasswordIcon // Use certificate icon if available
    }
  };

  const profileTitles = {
    'profile': 'My Profile',
    'fees': 'Fees Payment',
    'certificate': 'Certificate',
    'change-password': 'Change Password'
  };

  // Custom breadcrumb factory for profile pages (optional)
  const profileBreadcrumbFactory = (basePath, currentPage) => {
    const breadcrumbs = [
      { label: 'Home', path: '/dashboard', active: false },
      { label: 'Profile', path: '/profile', active: currentPage === 'profile' }
    ];

    if (currentPage !== 'profile') {
      breadcrumbs.push({
        label: profileTitles[currentPage],
        path: `/profile/${currentPage}`,
        active: true
      });
    }

    return breadcrumbs;
  };

  // Optional right content for specific pages
  const getHeaderRightContent = (currentPage) => {
    if (currentPage === 'certificate') {
      return (
        <Button
          text="Download Certificate"
          onClick={() => {
            console.log('Downloading certificate...');
            // Add your download logic here
          }}
          state="Disabled"
        />
      );
    }
    return null;
  };

  // Use the centralized hook
  const {
    pageComponent,
    pageIcon,
    pageTitle,
    breadcrumbs,
    currentPage,
    showIcon
  } = usePageContainer({
    basePath: 'profile',
    defaultPage: 'profile',
    pages: profilePages,
    pageTitles: profileTitles,
    breadcrumbFactory: profileBreadcrumbFactory,
    pagesWithoutIcons: ['certificate'] // Specify pages that shouldn't show icons
  });

  return (
    <PageContainerLayout
      title={pageTitle}
      icon={pageIcon}
      breadcrumbs={breadcrumbs}
      rightContent={getHeaderRightContent(currentPage)}
      showIcon={showIcon} // Control icon display based on the pagesWithoutIcons array
    >
      {pageComponent}
    </PageContainerLayout>
  );
};

export default ProfilePageContainer;